(() => {
  if (customElements.get('shipping-benefits')) return;

  class ShippingBenefits extends HTMLElement {
    connectedCallback() {
      // Wait for child markup when the editor inserts an already-defined element.
      this.initTimer = setTimeout(() => this.init(), 0);
    }

    init() {
      const autoplay = ['row_carousel', 'carousel'].includes(this.dataset.mobileLayout);
      if (!autoplay) return;

      const track = this.querySelector('[data-benefits-track]');
      if (!track) return;
      const slides = Array.from(track.querySelectorAll('.product-trust-badges__item'));
      if (!slides.length) return;
      const mobile = window.matchMedia('(max-width: 749px)');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const intervalSeconds = Number.parseInt(this.dataset.autoplayInterval, 10) || 5;
      const controller = new AbortController();
      this.controller = controller;
      const options = { signal: controller.signal };
      let index = 0;
      let interacting = false;
      let hovering = false;

      const stop = () => clearInterval(this.autoplayTimer);
      const start = () => {
        stop();
        if (!autoplay || !mobile.matches || reducedMotion.matches || interacting ||
            hovering || document.hidden || this.contains(document.activeElement)) return;
        this.autoplayTimer = setInterval(() => goTo((index + 1) % slides.length), intervalSeconds * 1000);
      };

      const updateIndex = () => {
        const left = track.getBoundingClientRect().left;
        index = slides.reduce((nearest, slide, i) =>
          Math.abs(slide.getBoundingClientRect().left - left) <
          Math.abs(slides[nearest].getBoundingClientRect().left - left) ? i : nearest, 0);
      };

      const goTo = (i) => {
        if (!mobile.matches) return;
        const slide = slides[Math.max(0, Math.min(slides.length - 1, i))];
        track.scrollTo({
          left: track.scrollLeft + slide.getBoundingClientRect().left - track.getBoundingClientRect().left,
          behavior: reducedMotion.matches ? 'instant' : 'smooth'
        });
      };

      track.addEventListener('scroll', updateIndex, { ...options, passive: true });
      track.addEventListener('keydown', (event) => {
        if (event.target !== track || !mobile.matches) return;
        const target = { ArrowLeft: index - 1, ArrowRight: index + 1, Home: 0, End: slides.length - 1 }[event.key];
        if (target === undefined) return;
        event.preventDefault();
        goTo(target);
      }, options);

      if (autoplay) {
        this.addEventListener('mouseenter', () => { hovering = true; stop(); }, options);
        this.addEventListener('mouseleave', () => { hovering = false; start(); }, options);
        this.addEventListener('focusin', stop, options);
        this.addEventListener('focusout', () => {
          clearTimeout(this.focusTimer);
          this.focusTimer = setTimeout(start, 0);
        }, options);
        this.addEventListener('pointerdown', () => { interacting = true; stop(); }, options);
        const endInteraction = () => { interacting = false; start(); };
        window.addEventListener('pointerup', endInteraction, options);
        window.addEventListener('pointercancel', endInteraction, options);
        document.addEventListener('visibilitychange', start, options);
        reducedMotion.addEventListener('change', start, options);
      }

      const syncLayout = () => {
        track.tabIndex = mobile.matches ? 0 : -1;
        track.scrollTo({ left: 0, behavior: 'instant' });
        updateIndex();
        start();
      };
      mobile.addEventListener('change', syncLayout, options);
      this.resizeObserver = new ResizeObserver(updateIndex);
      this.resizeObserver.observe(track);
      this.setAttribute('data-ready', '');
      syncLayout();
    }

    disconnectedCallback() {
      clearTimeout(this.initTimer);
      clearTimeout(this.focusTimer);
      clearInterval(this.autoplayTimer);
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.removeAttribute('data-ready');
    }
  }

  customElements.define('shipping-benefits', ShippingBenefits);
})();
